import Vue from "vue";
import Vuex from "vuex";

import worker from "@/stores/worker";
import setting from "@/stores/setting";
import workerAnalytic from "@/stores/worker-analytic";
import serviceActuator from "@/stores/service-actuator";

// Data stores
import xAccount from "@/stores/data/x-account";
import facebookAccount from "@/stores/data/fb-account";
import hotmailAccount from "@/stores/data/hotmail-account";
import emailAccount from "@/stores/data/email-account";
import adAccount from "@/stores/data/ad-account";

import tag from "@/stores/tag";
import auth from "@/stores/auth";
import scenario from "@/stores/scenario";
import job from "@/stores/job";
import task from "@/stores/task";
import director from "@/stores/director";
import background from "@/stores/background";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
    worker,
		workerAnalytic,
		serviceActuator,
		setting,
		facebookAccount,
		hotmailAccount,
		xAccount,
		emailAccount,
		tag,
		auth,
		scenario,
		job,
		task,
		director,
		adAccount,
		background
	}
});

export default store;